// extracted by mini-css-extract-plugin
module.exports = {"root":"CheatSheet_root__2ifUK","header":"CheatSheet_header__1SwWk","content":"CheatSheet_content__2eNFJ"};